<template>
  <div id="invoiceForm" style="width: 100%;height: 100%">
    <el-dialog :visible.sync="visible" @close="visible = false" width="65%" center :title="dialogTitle"
      :close-on-click-modal="false">
      <el-form :model="invoiceForm" :rules="rules" ref="invoiceForm" class="el-form--label-justify">
        <el-row v-if="visibleCodeNum">
          <el-col :span="11">
            <el-form-item label="发票代码：" :label-width="labelWidth" prop="INVOICE_CODE">
              <el-input v-model="invoiceForm.INVOICE_CODE" :disabled="disabledCodeNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="发票起始号码" :label-width="labelWidth" prop="INVOICE_NUM">
              <el-input v-model.number="invoiceForm.INVOICE_NUM" :disabled="disabledCodeNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="客户：" :label-width="labelWidth" prop="CUSTOMER_NAME">
              <el-input v-model="invoiceForm.CUSTOMER_NAME" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="发票类型：" :label-width="labelWidth" prop="INVOICE_TYPE">
              <el-select v-model="invoiceForm.INVOICE_TYPE" placeholder="请选择" style="width:100%" clearable
                :disabled="isDetail">
                <el-option v-for="item in incomeTypeList" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="购买方：" :label-width="labelWidth" prop="BUY_COMPANY_NAME">
              <el-autocomplete class="inline-input" v-model="invoiceForm.BUY_COMPANY_NAME"
                :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"
                style="width:100%" clearable @clear="clearBuyer" :disabled="isDetail">
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="销售方：" :label-width="labelWidth" prop="SELL_COMPANY_NAME">
              <el-input v-model="invoiceForm.SELL_COMPANY_NAME" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="纳税人识别号：" :label-width="labelWidth" prop="BUY_COMPANY_CODE">
              <el-input v-model="invoiceForm.BUY_COMPANY_CODE" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="纳税人识别号：" :label-width="labelWidth" prop="SELL_COMPANY_CODE">
              <el-input v-model="invoiceForm.SELL_COMPANY_CODE" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="地址：" :label-width="labelWidth" prop="BUYER_ADDRESS">
              <el-input v-model="invoiceForm.BUYER_ADDRESS" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="地址：" :label-width="labelWidth" prop="SELLER_ADDRESS">
              <el-input v-model="invoiceForm.SELLER_ADDRESS" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="电话：" :label-width="labelWidth" prop="BUYER_TELPHONE">
              <el-input v-model="invoiceForm.BUYER_TELPHONE" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="电话：" :label-width="labelWidth" prop="SELLER_TELPHONE">
              <el-input v-model="invoiceForm.SELLER_TELPHONE" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开户行：" :label-width="labelWidth" prop="BUYER_BANK_NAME">
              <el-input v-model="invoiceForm.BUYER_BANK_NAME" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="开户行：" :label-width="labelWidth" prop="SELLER_BANK_NAME">
              <el-input v-model="invoiceForm.SELLER_BANK_NAME" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="银行账户：" :label-width="labelWidth" prop="BUYER_BANK_ACCOUNT">
              <el-input v-model="invoiceForm.BUYER_BANK_ACCOUNT" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="银行账户：" :label-width="labelWidth" prop="SELLER_BANK_ACCOUNT">
              <el-input v-model="invoiceForm.SELLER_BANK_ACCOUNT" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开票金额(含税金额)：" :label-width="labelWidth" prop="INVOICE_FEE">
              <el-input v-model="invoiceForm.INVOICE_FEE" :placeholder="isDetail?'':`最大开票金额${this.requestData.maxFee.toFixed(2)}`" clearable
                :disabled="isDetail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="税额：" :label-width="labelWidth" prop="TAX_AMOUNT">
              <el-input v-model="invoiceForm.TAX_AMOUNT" clearable :disabled="isDetail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="发票摘要：" :label-width="labelWidth" prop="INVOICE_NAME">
              <el-input v-model="invoiceForm.INVOICE_NAME" clearable :disabled="isDetail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="开票内容：" :label-width="labelWidth" prop="INVOICE_CONTENT_ID">
              <el-select v-model="invoiceForm.INVOICE_CONTENT_ID" style="width:100%" :disabled="isDetail">
                <el-option v-for="item in invoiceContentList" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="备注：" :label-width="labelWidth" prop="COMMENT">
              <el-input v-model="invoiceForm.COMMENT" type="textarea" :rows="3" clearable :disabled="isDetail">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="附件：" :label-width="labelWidth">
              <el-button type="text" @click="downloadBindOrders">点击下载订单</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" v-if="!isDetail && fun_dic[115070101]">
        <el-button @click="visible = false">取 消</el-button>
        <el-button @click="submitRequest('invoiceForm')">提 交</el-button>
      </div>
      <div slot="footer" v-else-if="visibleAuditRequest && fun_dic[115070102]">
        <el-button @click="submitAuditRequest(2)">拒 绝</el-button>
        <el-button @click="submitAuditRequest(1)">通 过</el-button>
      </div>
      <div slot="footer" v-else-if="visibleAuditReturnInvoice && fun_dic[115070103]">
        <el-button @click="submitAuditReturnInvoice(2)">拒 绝</el-button>
        <el-button @click="submitAuditReturnInvoice(1)">通 过</el-button>
      </div>
      <div slot="footer" v-else>
        <el-button @click="visible = false">关 闭</el-button>
        <el-button @click="submitTurnToVoiced('invoiceForm')" v-if="visibleTurnToVoiced && fun_dic[115070104]">已 开
        </el-button>
        <el-button @click="returnVoice" v-if="visibleReturnInvoice && fun_dic[115070105]">退 票</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryBuyerInvoiceInfoListByName, submitRequest, invoiceRequestAudit, turnToInvoiced, returnInvoice, invoiceReturnAudit, exportInvoiceBindOrders,
} from 'api/invoice';
import { getActionFun } from 'api/login';

let maxFee = 0;
export default {
  props: {
    // 父组建传递的弹出框状态值
    invoiceFormVisible: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: '',
    },
    requestData: {
      type: Object,
      default: null,
    },
    detailData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      PAGE_ID: '1150701', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        115070101: 0,
        115070102: 0,
        115070103: 0,
        115070104: 0,
        115070105: 0,
      },
      dialogTitle: '',
      visible: this.invoiceFormVisible,
      invoiceForm: {},
      labelWidth: '160px',
      requestRules: {
        INVOICE_TYPE: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        BUY_COMPANY_ID: [{ required: true, message: '请选择购买方', trigger: 'change' }],
        BUY_COMPANY_CODE: [{ required: true, message: '请选择购买方', trigger: 'change' }],
        INVOICE_FEE: [
          { required: true, message: '请输入金额', trigger: 'change' },
          {
            validator(rule, value, callback) {
              if (/(^[1-9]\d*$)|(^(0|^[1-9]\d*)\.[0-9]{1,2}$)/.test(value)) {
                if (Number(value) <= maxFee) {
                  callback();
                } else {
                  callback(new Error('开票金额不得大于订单总金额'));
                }
              } else {
                callback(new Error('请输入正确金额'));
              }
            },
            trigger: 'change',
          },
        ],
        INVOICE_NAME: [{ required: true, message: '请输入发票摘要', trigger: 'change' }],
        TAX_AMOUNT: [
          {
            validator(rule, value, callback) {
              if (/(^[1-9]\d*$)|(^(0|^[1-9]\d*)\.[0-9]{1,2}$)/.test(value) || !value) {
                callback();
              } else {
                callback(new Error('请输入正确税额'));
              }
            },
            trigger: 'change',
          },
        ],
      },
      invoicedRules: {
        INVOICE_CODE: [{ required: true, message: '请填写发票代码', trigger: 'change' }],
        INVOICE_NUM: [
          { required: true, message: '请填写发票起始号码', trigger: 'change' },
          { type: 'number', message: '请填写数字', trigger: 'change' },
        ],
      },
      incomeTypeList: [{ id: 1, label: '增值税专用发票' }, { id: 2, label: '增值税普通发票' }],
      buyerInfoList: [],
      invoiceContentList: [{ id: 1, label: '明细' }, { id: 2, label: '汇总' }],
      invoiceTypeList: ['专票', '普票'],
    };
  },
  computed: {
    isDetail() {
      if (this.source == 'detail') return true;
      return false;
    },
    disabledCodeNum() {
      if (this.isDetail && this.detailData.STATUS != 2) return true;
      return false;
    },
    visibleCodeNum() {
      if (this.isDetail && this.detailData.STATUS > 1) return true;
      return false;
    },
    visibleAuditRequest() {
      if (this.isDetail && this.detailData.STATUS == 1) return true;
      return false;
    },
    visibleAuditReturnInvoice() {
      if (this.isDetail && this.detailData.STATUS == 4) return true;
      return false;
    },
    visibleTurnToVoiced() {
      if (this.isDetail && this.detailData.STATUS == 2) return true;
      return false;
    },
    visibleReturnInvoice() {
      if (this.isDetail && this.detailData.STATUS == 3) return true;
      return false;
    },
    rules() {
      let rules;
      switch (this.source) {
        case 'request':
          rules = this.requestRules;
          break;
        case 'detail':
          rules = this.detailData.STATUS == 2 ? this.invoicedRules : {};
          break;
        default:
          break;
      }
      return rules;
    },
  },
  methods: {
    // 功能控制
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 远程搜索开票单位信息
    querySearch(e, callback) {
      const params = {
        NAME: e,
        IS_SUPPLIER_CLIENT: this.requestData.isSupplierClient,
      };
      if (!this.requestData.isSupplierClient) {
        params.TC_ID = this.invoiceForm.tcID;
      } else {
        params.SUPPLIER_ID = this.invoiceForm.supplierID;
      }
      const snapArr = [];
      queryBuyerInvoiceInfoListByName(params).then((res) => {
        this.buyerInfoList = res;
        this.buyerInfoList.forEach((item) => {
          snapArr.push({ value: item.COMPANY_NAME, id: item.ID });
        });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
      callback(snapArr);
    },
    // 选择搜索出的单位
    handleSelect(e) {
      const formList = this.buyerInfoList.filter((item) => item.ID === e.id);
      // Object.assign(this.invoiceForm, formList[0]);
      this.invoiceForm = {
        ...this.invoiceForm,
        BUY_COMPANY_ID: formList[0].ID,
        BUY_COMPANY_NAME: formList[0].COMPANY_NAME,
        BUY_COMPANY_CODE: formList[0].COMPANY_CODE,
        BUYER_ADDRESS: formList[0].ADDRESS,
        BUYER_TELPHONE: formList[0].TELPHONE,
        BUYER_BANK_NAME: formList[0].BANK_NAME,
        BUYER_BANK_ACCOUNT: formList[0].BANK_ACCOUNT,
      };
    },
    submitRequest(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const params = {
            SELL_COMPANY_ID: this.invoiceForm.SELL_COMPANY_ID,
            SELL_COMPANY_CODE: this.invoiceForm.SELL_COMPANY_CODE,
            IS_SUPPLIER_CLIENT: this.requestData.isSupplierClient,
            BUY_COMPANY_ID: this.invoiceForm.BUY_COMPANY_ID,
            BUY_COMPANY_CODE: this.invoiceForm.BUY_COMPANY_CODE,
            INVOICE_FEE: this.invoiceForm.INVOICE_FEE,
            INVOICE_TYPE: this.invoiceForm.INVOICE_TYPE,
            INVOICE_NAME: this.invoiceForm.INVOICE_NAME,
            INVOICE_CONTENT_ID: this.invoiceForm.INVOICE_CONTENT_ID,
            ORDER_LIST: this.orderList,
          };
          params[this.requestData.isSupplierClient ? 'SUPPLIER_ID' : 'TC_ID'] = this.requestData.isSupplierClient ? this.invoiceForm.supplierID : this.invoiceForm.tcID;
          if (this.invoiceForm.TAX_AMOUNT) {
            params.TAX_AMOUNT = this.invoiceForm.TAX_AMOUNT;
          }
          if (this.invoiceForm.COMMENT) {
            params.COMMENT = this.invoiceForm.COMMENT;
          }
          submitRequest(params).then((res) => {
            this.$message.show({ text: '提交成功', type: 'success' });
            this.visible = false;
          }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
        }
      });
    },
    clearBuyer() {
      this.invoiceForm = {
        ...this.invoiceForm,
        BUY_COMPANY_ID: '',
        BUY_COMPANY_NAME: '',
        BUY_COMPANY_CODE: '',
        BUYER_ADDRESS: '',
        BUYER_TELPHONE: '',
        BUYER_BANK_NAME: '',
        BUYER_BANK_ACCOUNT: '',
      };
    },
    async submitAuditRequest(FLAG) {
      const params = {
        ID: this.invoiceForm.ID,
        FLAG,
      };
      if (FLAG == 2) {
        await this.$prompt('请输入拒绝理由：', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', inputValue: '',
        // eslint-disable-next-line no-console
        }).then(({ value }) => params.COMMENT = value).catch((err) => { console.log(err); });
      }
      invoiceRequestAudit(params).then((res) => {
        this.$message.show({ text: `发票申请已${FLAG == 1 ? '通过' : '拒绝'}`, type: 'success' });
        this.visible = false;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    submitTurnToVoiced(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const params = {
            ID: this.invoiceForm.ID,
            BUY_COMPANY_ID: this.invoiceForm.BUY_COMPANY_ID,
            SELL_COMPANY_ID: this.invoiceForm.SELL_COMPANY_ID,
            INVOICE_CODE: this.invoiceForm.INVOICE_CODE,
            INVOICE_NUM: this.invoiceForm.INVOICE_NUM,
            INVOICE_TYPE: this.invoiceForm.INVOICE_TYPE,
          };
          turnToInvoiced(params).then((res) => {
            if (res.length == 0) {
              this.$message.show({ text: `今天的${this.invoiceTypeList[this.invoiceForm.INVOICE_TYPE - 1]}已经处理结束`, type: 'success' });
              this.visible = false;
            } else {
              this.invoiceForm = {
                ...this.getDetail(res[0]),
                STATUS: 2,
              };
              this.$message.show({ text: '发票已开，进入下一张发票', type: 'success' });
            }
          }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
        }
      });
    },
    async submitAuditReturnInvoice(FLAG) {
      const params = {
        ID: this.invoiceForm.ID,
        FLAG,
      };
      if (FLAG == 2) {
        await this.$prompt('请输入拒绝理由：', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', inputValue: '',
        // eslint-disable-next-line no-console
        }).then(({ value }) => params.COMMENT = value).catch((err) => { console.log(err); });
      }
      invoiceReturnAudit(params).then((res) => {
        this.$message.show({ text: `退票申请已${FLAG == 1 ? '通过' : '拒绝'}`, type: 'success' });
        this.visible = false;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    getDetail(data) {
      return {
        ID: data.ID,
        INVOICE_CODE: data.INVOICE_CODE,
        INVOICE_NUM: data.INVOICE_NUM,
        CUSTOMER_NAME: data.NAME,
        BUY_COMPANY_ID: data.BUY_COMPANY_ID,
        BUY_COMPANY_NAME: data.BUY_COMPANY_NAME,
        BUY_COMPANY_CODE: data.BUY_COMPANY_CODE,
        BUYER_ADDRESS: data.BUY_ADDRESS,
        BUYER_TELPHONE: data.BUY_TELPHONE,
        BUYER_BANK_NAME: data.BUY_BANK_NAME,
        BUYER_BANK_ACCOUNT: data.BUY_BANK_ACCOUNT,
        SELL_COMPANY_ID: data.SELL_COMPANY_ID,
        SELL_COMPANY_NAME: data.SELL_COMPANY_NAME,
        SELL_COMPANY_CODE: data.SELL_COMPANY_CODE,
        SELLER_ADDRESS: data.SELL_ADDRESS,
        SELLER_TELPHONE: data.SELL_TELPHONE,
        SELLER_BANK_NAME: data.SELL_BANK_NAME,
        SELLER_BANK_ACCOUNT: data.SELL_BANK_ACCOUNT,
        INVOICE_TYPE: data.INVOICE_TYPE,
        INVOICE_FEE: data.INVOICE_FEE,
        TAX_AMOUNT: data.TAX_AMOUNT,
        INVOICE_NAME: data.INVOICE_NAME,
        INVOICE_CONTENT_ID: data.INVOICE_CONTENT_ID,
        COMMENT: data.COMMENT,
        isSupplierClient: data.isSupplierClient,
      };
    },
    async returnVoice() {
      await this.$prompt('请输入退票理由：', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', inputValue: '',
      }).then(({ value }) => {
        const params = { ID: this.invoiceForm.ID, COMMENT: value };
        returnInvoice(params).then((res) => {
          this.$message.show({ text: '已申请退票', type: 'success' });
          this.visible = false;
        }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
      // eslint-disable-next-line no-console
      }).catch((err) => { console.log(err); });
    },
    downloadBindOrders() {
      const params = {
        ID: this.invoiceForm.ID,
        ORDER_LIST: this.orderList,
        IS_SUPPLIER_CLIENT: this.invoiceForm.isSupplierClient,
      };
      exportInvoiceBindOrders(params).then((res) => {
        window.location.href = this.$util.getURLLocalHost(res[0].URL[0].FILE_PATH);
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
  },
  watch: {
    // 监听--向父组件更新状态值
    visible(newVal, oldVal) {
      this.$emit('closeDialog', newVal);
    },
  },
  created() {
    switch (this.source) {
      case 'request':
        this.invoiceForm = {
          INVOICE_CONTENT_ID: 1,
          CUSTOMER_NAME: this.requestData.BUYER[0].NAME,
          BUY_COMPANY_ID: this.requestData.BUYER[0].ID,
          BUY_COMPANY_NAME: this.requestData.BUYER[0].COMPANY_NAME,
          BUY_COMPANY_CODE: this.requestData.BUYER[0].COMPANY_CODE,
          BUYER_ADDRESS: this.requestData.BUYER[0].ADDRESS,
          BUYER_TELPHONE: this.requestData.BUYER[0].TELPHONE,
          BUYER_BANK_NAME: this.requestData.BUYER[0].BANK_NAME,
          BUYER_BANK_ACCOUNT: this.requestData.BUYER[0].BANK_ACCOUNT,
          SELL_COMPANY_ID: this.requestData.SELLER[0].ID,
          SELL_COMPANY_NAME: this.requestData.SELLER[0].COMPANY_NAME,
          SELL_COMPANY_CODE: this.requestData.SELLER[0].COMPANY_CODE,
          SELLER_ADDRESS: this.requestData.SELLER[0].ADDRESS,
          SELLER_TELPHONE: this.requestData.SELLER[0].TELPHONE,
          SELLER_BANK_NAME: this.requestData.SELLER[0].BANK_NAME,
          SELLER_BANK_ACCOUNT: this.requestData.SELLER[0].BANK_ACCOUNT,
          tcID: this.requestData.tcID,
          supplierID: this.requestData.supplierID,
          isSupplierClient: this.requestData.isSupplierClient,
        };
        this.orderList = this.requestData.orderList;
        this.dialogTitle = '申请发票';
        maxFee = this.requestData.maxFee;

        break;

      case 'detail':
        this.invoiceForm = {
          ...this.getDetail(this.detailData),
          STATUS: this.detailData.STATUS,
        };
        this.orderList = this.detailData.orderList;
        this.dialogTitle = '发票信息';

        break;
      default:
        break;
    }

    this.queryBeforeFun();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/invoiceForm.vue